<template>
  <svg class="w-full h-full" viewBox="0 0 111 150" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1577_4691)">
  <path d="M-54 150V121.31L29.5759 32.4324L-54 32.4324L-54 0L66.0624 0L81.343 16.2162L81.343 150H49.2225L49.2225 57.0686L-34.6653 150H-54Z" stroke="#8AB9B7"/>
  <path d="M66.1133 83.8857L66.1133 74.3223L93.9719 44.6966L66.1133 44.6966V33.8857L106.134 33.8857L111.228 39.2911V83.8857H100.521V52.9086L72.5582 83.8857H66.1133Z" fill="#8AB9B7" fill-opacity="0.25"/>
  </g>
  <defs>
  <clipPath id="clip0_1577_4691">
  <rect width="111" height="150" fill="white"/>
  </clipPath>
  </defs>
  </svg>
</template>
